import { createBreakpoints } from '@chakra-ui/theme-tools';
/**
 * Breakpoints for responsive design
 * chakra-ui styled-system is mobile first & uses `min-width`
*/

var breakpoints = createBreakpoints({
  sm: '30em',
  // 480px
  md: '48em',
  // 768px
  landscape: '812px',
  // mobile landscape
  ipadPro: '834px',
  lg: '62em',
  // 991px
  tablet: '64em',
  // 1024px
  smallDesktop: '1025px',
  xl: '80em',
  // 1280px
  baseDesktop: '90em',
  // 1440px
  largerDesktop: '95em',
  // 1520px
  '2xl': '96em' // 1536px

});
export default breakpoints;
//# sourceMappingURL=breakpoints.js.map